import {
    getPaymentMethod,
    listPaymentMethods
} from './queries';
import {
    createPaymentMethod,
    deletePaymentMethod,
    updatePaymentMethod,
} from './mutations';

import {GraphQLQuery,} from '@aws-amplify/api';
import {
    CreatePaymentMethod,
    DeletePaymentMethod,
    GetPaymentMethod,
    ListPaymentMethods,
    PaymentMethod,
    UpdatePaymentMethod
} from "../types.ts";
import {generateClient} from "aws-amplify/api";


const client = generateClient();

export const fetchRecords = async (filter: object, limit?: number, nextToken?: string) => {

    const response = await client.graphql<GraphQLQuery<ListPaymentMethods>>({
                                                                                query: listPaymentMethods,
                                                                                variables: {filter: filter, limit, nextToken},
                                                                            });
    return response.data?.listPaymentMethods;
};

export const fetch = async (id: string) => {
    const response = await client.graphql<GraphQLQuery<GetPaymentMethod>>({
                                                                              query: getPaymentMethod,
                                                                              variables: {id: id},
                                                                          });
    return response.data?.getPaymentMethod;
};

export const add = async (payload: object) => {

    const response = await client.graphql<GraphQLQuery<CreatePaymentMethod>>({
                                                                                 query: createPaymentMethod,
                                                                                 variables: {input: payload},
                                                                             });

    return response.data?.createPaymentMethod;
};

export const update = async (_id: string, record: PaymentMethod) => {

    const payload = {...record} as Record<string, unknown>;
    delete payload.created;
    delete payload.livemode;

    const response = await client.graphql<GraphQLQuery<UpdatePaymentMethod>>({
                                                                                 query: (updatePaymentMethod),
                                                                                 variables: {input: payload},
                                                                             });
    return response.data?.updatePaymentMethod;
};

export const deleteRecord = async (id: string) => {
    const response = await client.graphql<GraphQLQuery<DeletePaymentMethod>>({
                                                                                 query: (deletePaymentMethod),
                                                                                 variables: {input: {id: id}},

                                                                             });
    return response.data?.deletePaymentMethod;
};
